import { Navigate } from 'react-router-dom';

export default function ScDashboard() {
  // Le spécialiste de contenu est l'administrateur du système
  // Rediriger vers le dashboard admin
  return <Navigate to="/admin" replace />;
}
